'use client'
import { SelectionDictionaryParams, dictionaryQueries } from '../../api'
import { QueryHandler } from '@/shared/ui/query-handler'
import { UseQueryResult } from '@tanstack/react-query'
import { AccordionCheckbox, AccordionCheckboxProps } from '@/shared/ui/checkbox'

interface ComponentProps extends Omit<AccordionCheckboxProps, 'data'> {
  dictionary: SelectionDictionaryParams
}

export default function Component({ dictionary, ...props }: ComponentProps) {
  const dictionaryQuery = dictionaryQueries.useGet(dictionary)

  return (
    <div className="flex flex-wrap gap-3 w-full">
      <QueryHandler queryResult={dictionaryQuery as UseQueryResult}>
        <AccordionCheckbox
          {...props}
          data={dictionaryQuery.data}
          valueFieldName="id"
          labelFieldName="name"
          iconFieldName="image"
        />
      </QueryHandler>
    </div>
  )
}
